import { dataHooks } from '../../../../libs/dataHooks';

export const megaMenuDropdownDataHooks = dataHooks<{
  dropdownSection: { id: string };
  itemLink: { id: string };
}>('mega-menu-dropdown');
